import { requestMain, requestBaseService } from './index'
import { generateQueryString } from '../../utils/query'
import { objectToFormData } from '../../utils'

export const getConversation = payload => {
  return requestBaseService({
    url: `crm/ex/v1/tanya-saham/${payload}`,
    method: 'GET',
  })
}

export const closeConversation = payload => {
  return requestBaseService({
    url: `crm/ex/v1/tanya-saham/end-chat/${payload}`,
    method: 'DELETE',
  })
}

export const getChats = (payload) => {
  return requestBaseService({
    url: `crm/ex/v1/tanya-saham/chat-detail/${payload.id}`,
    method: 'GET',
    params: payload.params
  })
}

export const replyChat = (payload) => {
  return requestBaseService({
    url: 'crm/ex/v1/tanya-saham/reply',
    method: 'POST',
    data: payload,
  })
}

export const getStatusQa = () => {
  return requestMain({
    url: 'qa-check',
    method: 'GET',
  })
}

export const autoAnswer = (payload) => {
  const params = generateQueryString(payload.params)
  return requestMain({
    url: `qa-auto-answer?${params}`,
    method: 'GET',
  })
}

export const autoAnswerV2 = (payload) => {
  return requestMain({
    url: 'qa-auto-answer-v2',
    method: 'POST',
    data: payload.body
  })
}

export const checkAutoAnswerV2 = (payload) => {
  const params = generateQueryString(payload.params)
  return requestMain({
    url: `qa-auto-answer-v2?${params}`,
    method: 'GET',
  })
}

export const getPortfolio = (payload) => {
  return requestBaseService({
    url: `/crm/ex/v1/tanya-saham/portofolio/${payload}/latest`,
    method: "GET",
  });
};

export const addPortfolio = (payload) => {
  return requestBaseService({
    url: `/crm/ex/v1/tanya-saham/portofolio/add`,
    method: "POST",
    data: objectToFormData(payload),
  });
}

export const editPortfolio = (payload) => {
  return requestBaseService({
    url: `/crm/ex/v1/tanya-saham/portofolio/update/${payload.id}`,
    method: "PUT",
    data: objectToFormData(payload.data),
  });
}

export const addPortfolioDetail = (payload) => {
  return requestBaseService({
    url: `/crm/ex/v1/tanya-saham/portofolio/detail`,
    method: "POST",
    data: payload
  });
}

export const editPortfolioDetail = (payload) => {
  return requestBaseService({
    url: `/crm/ex/v1/tanya-saham/portofolio/detail/${payload.id}`,
    method: "PUT",
    data: payload.data,
  });
}

export const deletePortfolioDetail = (payload) => {
  return requestBaseService({
    url: `/crm/ex/v1/tanya-saham/portofolio/detail/${payload}`,
    method: "DELETE",
  });
}

export const addQAPortfolioTicket = (payload) => {
  return requestBaseService({
    url: `/crm/ex/v1/tanya-saham/portofolio/send`,
    method: "POST",
    data: payload
  });
}

export const getQaList = (payload) => {
  return requestBaseService({
    url: '/crm/ex/v1/tanya-saham',
    method: 'GET',
    params: payload,
  })
}

export const deleteQATicket = (payload) => {
  return requestBaseService({
    url: '/crm/ex/v1/tanya-saham/delete-chat',
    method: 'DELETE',
    data: payload
  })
}

export const getTanyaSahamCheck = () => {
  return requestBaseService({
    url: 'crm/ex/v1/tanya-saham/check',
    method: 'GET',
  })
}

export const postChatRating = (payload) => {
  return requestBaseService({
    url: '/crm/ex/v1/tanya-saham/rating',
    method: 'POST',
    data: payload
  })
}

export const getChatRating = payload => {
  return requestBaseService({
    url: `/crm/ex/v1/tanya-saham/rating/${payload}`,
    method: 'GET',
  })
}

export const postOtherQuestion = (payload) => {
  return requestBaseService({
    url: '/crm/ex/v1/tanya-saham/lainnya',
    method: 'POST',
    data: payload,
  })
}


export const postQATanyaSaham = (payload) => {
  return requestBaseService({
    url: `/crm/ex/v1/tanya-saham`,
    method: "POST",
    data: payload
  });
}

const Qa = {
  getConversation,
  closeConversation,
  getChats,
  replyChat,
  autoAnswer,
  autoAnswerV2,
  checkAutoAnswerV2,
  getPortfolio,
  addPortfolio,
  editPortfolio,
  addPortfolioDetail,
  editPortfolioDetail,
  deletePortfolioDetail,
  addQAPortfolioTicket,
  getQaList,
  deleteQATicket,
  getTanyaSahamCheck,
  postChatRating,
  getChatRating,
  postOtherQuestion,
  postQATanyaSaham,
  getStatusQa
}

export default Qa
